import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { NoAuthGuard } from './guards/no-auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/home/home.page').then(m => m.HomePage),
    canActivate: [AuthGuard],
  },
  {
    path: 'user-info',
    loadComponent: () => import('./pages/user-info/user-info.page').then(m => m.UserInfoPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'sign-in',
    loadComponent: () => import('./pages/sign-in/sign-in.page').then(m => m.SignInPage),
    canActivate: [NoAuthGuard],
  },
  {
    path: 'scans/new',
    loadComponent: () => import('./pages/new-scan/new-scan.page').then(m => m.NewScanPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'scans/:id',
    loadComponent: () => import('./pages/view-scan/view-scan.page').then(m => m.ViewScanPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'privacy',
    loadComponent: () => import('./pages/privacy/privacy.page').then(m => m.PrivacyPage),
  },
  {
    path: 'terms',
    loadComponent: () => import('./pages/terms/terms.page').then(m => m.TermsPage),
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
